import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function Transformation() {
  return <section className="py-24 bg-[#1a1f3a] text-[#faf8f5] relative overflow-hidden" data-id="element-221">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-222"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-223">
        <FadeIn data-id="element-224">
          <div className="text-center mb-12" data-id="element-225">
            <Sparkles className="w-12 h-12 text-[#d4a574] mx-auto mb-6" data-id="element-226" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-227">
              Imagina esto{' '}
              <span className="text-[#8da399] font-sans text-2xl font-normal" data-id="element-228">
                (sin fantasía)
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-229">
          {['Te despiertas y no odias el día antes de empezar.', 'Llegan las 15:00 y no te desplomas.', 'Dejas de pelearte con los antojos como si fueran un defecto moral.', 'Vuelves a sentirte “tú”: clara, presente, funcional.'].map((item, i) => <FadeIn key={i} delay={i * 150} data-id="element-230">
              <div className="bg-[#ffffff05] p-6 rounded-xl border border-[#ffffff10] hover:bg-[#ffffff10] transition-colors" data-id="element-231">
                <p className="text-lg font-light leading-relaxed" data-id="element-232">{item}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={600} data-id="element-233">
          <div className="text-center" data-id="element-234">
            <p className="text-2xl font-serif text-[#d4a574]" data-id="element-235">
              No perfecta. Pero estable.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}